import { TableFilter } from 'shared/UI/UIKit/TableFilter';
import { useScheduleFilters } from '../model';
import styles from './styles.module.scss';

export const ScheduleFilters = () => {
  const {
    state: { filterFields },
    methods: { onFilterChange },
  } = useScheduleFilters();

  return (
    <TableFilter
      fields={filterFields}
      onFilterChange={onFilterChange}
      siderClassName={styles.sider}
    />
  );
};
